var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.883 0h-4.069v16.348c0 1.948-1.565 3.548-3.513 3.548s-3.513-1.6-3.513-3.548A3.56 3.56 0 0 1 8.197 12.8V8.696c-4.14.07-7.479 3.443-7.479 7.652C.718 20.59 4.127 24 8.336 24c4.208 0 7.617-3.444 7.617-7.652V7.965a9.461 9.461 0 0 0 5.391 1.809V5.67A5.652 5.652 0 0 1 15.884 0Z",
    fill: "currentColor"
  })));
};
export default SvgTiktok;